import e from'./../../ext-esm/style-inject/dist/style-inject.es.js';var t={spacing:"8",root:"Stepper_root__FV6wF"};e(".Stepper_root__FV6wF{display:flex;flex-flow:row wrap;gap:16px;justify-content:space-between}");export{t as default};
